'use strict';

var _keypad = require('./keypad.provider');

var _keypad2 = require('./keypad.directive');

angular.module('bc.AngularKeypad', []).provider('bcKeypadConfig', _keypad.KeypadConfig).directive('bcKeypad', _keypad2.KeypadDirective);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/